export default __webpack_public_path__ + "static/cccf-c012ee5ef655bd7f68f7d8e3c2938d89.jpg";